import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtonCorner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 5,
	viewBox: "0 0 5 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0H5V5H4V1H0V0Z",
		fill: "currentColor"
	})
});
export { SvgButtonCorner as ReactComponent };
